import React from 'react';

export default function UpgradeModal({ onDismiss, onNavigate }) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4"
      style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)' }}
    >
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 text-center relative">
        <div className="text-5xl mb-4">🌟</div>
        <h2 className="text-xl font-bold mb-3" style={{ color: '#1B3A5C' }}>
          You've Used All 5 Free Generations This Month
        </h2>
        <p className="text-gray-500 text-sm leading-relaxed mb-8">
          Upgrade to Pastor Pro for unlimited access to all 10 tools —{' '}
          <span className="font-semibold text-gray-700">$15/month</span>. Cancel anytime.
        </p>

        <div className="space-y-3">
          <button
            onClick={() => { onDismiss(); if (onNavigate) onNavigate('upgrade'); }}
            className="w-full py-3 rounded-xl text-white font-semibold text-base hover:opacity-90 transition-opacity"
            style={{ backgroundColor: '#C8921A' }}
          >
            Upgrade to Pro →
          </button>
          <button
            onClick={onDismiss}
            className="w-full py-2.5 text-sm text-gray-400 hover:text-gray-600 transition-colors"
          >
            Remind me next month
          </button>
        </div>

        <p className="text-xs text-gray-300 mt-4">
          Your free generations reset on the 1st of every month.
        </p>
      </div>
    </div>
  );
}
